<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div  @click="$emit('close')" class="modal-card">
      <img v-if="imageLink" :src="imageLink" class="profile-large" />

      <img
        v-if="verifiedLevel > 0"
        :src="getVerifiedIcon(verifiedLevel)"
        :alt="$t('profile.public_card.verified_alt')"
        class="verified-icon"
      /> 
      <p class="title">{{ userName }}</p> 
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userName: {
      type: String,
      required: true
    },
    imageLink: {
      type: String,
      required: false
    },
    verifiedLevel: {
      type: Number,
      required: false,
      default: 0
    }
  },
  methods: {
  getVerifiedIcon(level) {
    try {
      return require(`@/assets/icon/profile/level/${level}.svg`);
    } catch (e) {
      try {
        return require(`@/assets/icon/profile/level/${level}.png`);
      } catch (err) {
        console.error(`Seviye ${level} için ikon bulunamadı.`);
        return '';
      }
    }
  }
}

  
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-card {
  background: #050505;
  border: 1px solid #023032;
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.profile-large {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 10px;
} 
.verified-icon {
  height: 100px;  
  margin: 10px;
  margin-top: 1em;
} 
.title{ font-size: 1rem; font-weight: 500;  margin: 0;}
</style>